import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpSentEvent,
  HttpHeaderResponse,
  HttpProgressEvent,
  HttpUserEvent,
} from '@angular/common/http';

import { GeneralUrlsService } from '@/core/services/http/api-url/general-urls.service';
import {ToastService} from "@/core/services/internal/toast.service";

@Injectable({
  providedIn: 'root'
})
export class SuccessInterceptor implements HttpInterceptor {

  constructor(
    private toastService: ToastService,
    private router: Router,
    private endpointUrlsService: GeneralUrlsService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(evt => this.handleSuccess(evt))
    );
  }

  private handleSuccess(
    evt: HttpSentEvent | HttpHeaderResponse | HttpResponse<any> | HttpProgressEvent | HttpUserEvent<any>
  ): void {
    if (!(evt instanceof HttpResponse)) return;

    if (evt.ok && evt.body) {
      const rawUrl = evt.url || '';
      const path = this.endpointUrlsService.getPath([rawUrl])[0] ?? '';

      // Ignore success toast for internal-only URLs
      if (!this.endpointUrlsService.skipUrls.includes(path)) {
        this.toastService.showToast(
          evt.statusText || 'Success',
          evt.body.message || 'Success',
          'success',
          'success',
          true,
          5000
        );
      }
    }
  }
}
